import { MdClose } from "react-icons/md";
import "./Cart.scss";
// import { BsCartX } from "react-icons/bs";
import { CartItem } from "./CartItem/CartItem";
import { useContext } from "react";
import { Context } from "../../utils/context";
import {loadStripe} from "@stripe/stripe-js";
import {makePaymentRequest} from "../../utils/api"
import { useNavigate } from "react-router-dom";


export function Cart({setShowCart}) {

    const {cartItems, cartSubTotal} = useContext(Context);

    const stripePromise = loadStripe(
        process.env.REACT_APP_SRRIPE_PUBLISHABLE_KEY
    );

    const navigate = useNavigate();

    const handlePayment = async () =>{

        try {
            const stripe = await stripePromise;
            const res = await makePaymentRequest.post("/api/orders",{
                products: cartItems,
            });
    
            await stripe.redirectToCheckout({
                sessionId: res.data.stripeSession.id
            })

        }catch(error){
            console.log(error);
        }
    }



    return(
        <div className="cart-panel">
            <div className="opac-layer"></div>
            <div className="cart-content">
                <div className="cart-header">
                    <span className="heading">Shopping Cart</span>
                    <span onClick={()=>{setShowCart(false)}} className="close-btn">
                        <MdClose className="close-btn" />
                        <span className="text">Close</span>
                    </span>
                </div>

               {!cartItems?.length && <div className="empty-cart">
                    {/* <BsCartX /> */}
                    <span class="bi bi-cart text-white"></span>
                    <span className="text-white">No Products in the Cart.</span>
                 <buttonon onClick={() => navigate("/")} className="return-cta">RETURN TO SHOP</buttonon>
                </div>}

                {!!cartItems.length && <>
                <CartItem />
                <div className="cart-footer">
                    <div className="subtotal">
                        <span className="text">Subtotal:</span>
                        <span className="text total">&#8377; {cartSubTotal}</span>
                    </div>
                    <div className="button">
                        <button className="checkout-cta"
                        onClick={handlePayment}
                        >Checkout</button>
                    </div>
                </div>
                </>}
            </div>
        </div>
    )
};

 
